import React from "react"

interface PagingProps {
    total?: number
    page?: number
    size?: number
    changePage: (page: number) => void
}

const showSize = 2

function getPageCount(total: number, size: number) {
    let pageCount = total / size
    if (total % size) pageCount = pageCount + 1
    return pageCount;
}

function isShowFirstPageLink(page: number, count: number): boolean {
    return ((showSize * 2) + 1 < count)  && page - showSize > 1;
}

function isShowLastPageLink(page: number, count: number): boolean {
    return ((showSize * 2) + 1 < count) && count - (page + showSize) > 0;
}

function getStartPage(page: number, pageCount: number) {
    let startPage = page - showSize
    if (startPage <= 0) {
        startPage = 1
    }
    if ((pageCount - page) < showSize) {
        startPage = startPage - (showSize - (pageCount - page))
    }
    if (startPage < 1) return 1
    return startPage;
}

function getEndPage(page: number, pageCount: number) {
    let endPage = page + showSize
    if (endPage > pageCount) {
        endPage = pageCount
    }
    if ((page - showSize) <= 0) {
        endPage = endPage + (showSize - page + 1)
    }
    if (endPage > pageCount) return pageCount
    return endPage;
}

function getPagesToDisplay(pageCount: number, page: number): number[] {
    const pages = []
    let startPage = getStartPage(page, pageCount);
    let endPage = getEndPage(page, pageCount);
    for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
    }

    return pages
}

export const Pagination = ({page = 1, size = 20, total = 0, changePage}: PagingProps) => {
    let pageCount = parseInt(getPageCount(total, size).toString(), 10);
    const showFirstPageLink = isShowFirstPageLink(page, pageCount)
    const showLastPageLink = isShowLastPageLink(page, pageCount)

    // const pageArray = []
    // for (let i = 1; i <= pageCount; i++) {
    //     pageArray[i - 1] = i
    // }
    const pages = getPagesToDisplay(pageCount, page)
    return (
        <div className="mt20">
            <nav className="pagination is-centered is-rounded" role="navigation" aria-label="pagination">

                <ul className="pagination-list">
                    {
                        showFirstPageLink && (
                            <>
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <li><a className="pagination-link" aria-label="Goto page 1"
                                       onClick={() => changePage(1)}
                                >1</a></li>
                                <li><span className="pagination-ellipsis">&hellip;</span></li>
                            </>
                        )
                    }
                    {
                        pages.map(pageCount => {
                            return (
                                <React.Fragment key={pageCount}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <li><a className={`pagination-link ${page === pageCount ? "is-current" : ""}`}
                                           aria-label={`Goto page ${pageCount}`}
                                           onClick={() => changePage(pageCount)}
                                    >{pageCount}</a>
                                    </li>
                                </React.Fragment>
                            )
                        })
                    }
                    {
                        showLastPageLink && (
                            <>
                                <li><span className="pagination-ellipsis">&hellip;</span></li>
                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                <li><a className="pagination-link" aria-label="Goto page 1"
                                       onClick={() => changePage(pageCount)}
                                >{pageCount}</a></li>
                            </>
                        )
                    }
                </ul>
            </nav>
        </div>
    )
}
